import { arbitrum, arbitrumGoerli, avalanche, avalancheFuji, base, baseGoerli, bsc, celo, gnosis, goerli, mainnet, optimism, optimismGoerli, polygon, polygonMumbai, sepolia, } from "wagmi/chains";
import { z } from "zod";
export const chainIds = [
    mainnet.id,
    arbitrum.id,
    arbitrumGoerli.id,
    avalanche.id,
    avalancheFuji.id,
    base.id,
    baseGoerli.id,
    bsc.id,
    celo.id,
    gnosis.id,
    goerli.id,
    sepolia.id,
    optimism.id,
    optimismGoerli.id,
    polygon.id,
    polygonMumbai.id,
];
export const supportedNetwork = {
    mainnet,
    arbitrum,
    arbitrumGoerli,
    avalanche,
    avalancheFuji,
    base,
    baseGoerli,
    bsc,
    celo,
    gnosis,
    goerli,
    sepolia,
    optimism,
    optimismGoerli,
    polygon,
    polygonMumbai,
};
const supportedNetworks_ = Object.values(supportedNetwork).sort((a, b) => {
    const testnetA = !!a.testnet;
    const testnetB = !!b.testnet;
    if (testnetA !== testnetB) {
        return testnetA ? 1 : -1; // Put non-testnets first
    }
    return 0;
});
export const chainIdSchema = z.custom((value) => {
    return chainIds.some((x) => x === Number(value));
});
export const supportedNetworkSchema = z
    .object({
    id: chainIdSchema,
})
    .transform((x) => x);
export const supportedNetworks = supportedNetworks_;
